import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { safeReturnUrl } from '@portal/platform/guards';
import { LoginPage } from '@portal/ui';

interface LoginSearch {
  returnUrl?: string;
  passwordReset?: boolean;
}

export const Route = createFileRoute('/login')({
  validateSearch: (search: Record<string, unknown>): LoginSearch => ({
    returnUrl: safeReturnUrl(search['returnUrl']) ?? undefined,
    passwordReset:
      search['passwordReset'] === true || search['passwordReset'] === 'true' || undefined,
  }),
  // Already logged in (or just logged in, when the guards rerun): go where they were headed.
  beforeLoad: ({ context, search }) => {
    if (context.session.status === 'authenticated') {
      throw redirect({ href: search.returnUrl ?? '/dashboard' });
    }
  },
  component: Login,
});

function Login() {
  const { returnUrl, passwordReset } = Route.useSearch();
  const router = useRouter();
  return (
    <LoginPage
      passwordReset={passwordReset === true}
      onLoggedIn={() => void router.navigate({ href: returnUrl ?? '/dashboard' })}
    />
  );
}
